import { render, staticRenderFns } from "./shareCourse.vue?vue&type=template&id=5f9607f4&scoped=true&"
import script from "./shareCourse.vue?vue&type=script&lang=js&"
export * from "./shareCourse.vue?vue&type=script&lang=js&"
import style0 from "./shareCourse.vue?vue&type=style&index=0&id=5f9607f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9607f4",
  null
  
)

export default component.exports